"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notifications = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _colors = require("@cimpress/react-components/lib/colors");

var _SimpleDate = require("./SimpleDate");

var _InlineButton = require("./InlineButton");

var _BlockButton = require("./BlockButton");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const badgeStyle = {
  position: 'absolute',
  fontSize: '10px',
  top: '-4px',
  left: '12px',
  borderRadius: '50%',
  padding: '1px 4px',
  backgroundColor: _colors.danger.base,
  color: 'white'
};

class Notifications extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      show: false,
      windowHeight: 0
    });

    _defineProperty(this, "updateWindowDimensions", () => {
      this.setState({
        windowHeight: window.innerHeight
      });
    });

    _defineProperty(this, "handleClose", () => {
      if (this.props.onClose) {
        this.props.onClose();
      }

      this.setState({
        show: false
      });
    });

    _defineProperty(this, "handleOpen", () => {
      if (this.props.onOpen) {
        this.props.onOpen();
      }

      if (this.props.showNotificationsOnClick) {
        this.setState({
          show: true
        });
      }
    });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  render() {
    const _this$props = this.props,
          {
      onOpen,
      // eslint-disable-line @typescript-eslint/no-unused-vars,
      notifications = [],
      errorMessage,
      numberUnread = 0,
      snippetLength = 0,
      readMoreComponent,
      noNotificationsText = 'No unread notifications',
      dateTimeComponent = ({
        date
      }) => /*#__PURE__*/_react.default.createElement(_SimpleDate.SimpleDate, {
        date: date
      }),
      // eslint-disable-line react/prop-types,
      viewAllComponent,
      constraints = [{
        to: 'scrollParent',
        attachment: 'bottom',
        pin: ['left', 'right']
      }],
      showNotificationsOnClick = true
    } = _this$props,
          rest = _objectWithoutProperties(_this$props, ["onOpen", "notifications", "errorMessage", "numberUnread", "snippetLength", "readMoreComponent", "noNotificationsText", "dateTimeComponent", "viewAllComponent", "constraints", "showNotificationsOnClick"]);

    const formattedNotifications = /*#__PURE__*/_react.default.createElement("div", null, notifications.map((notification, idx) => {
      const tooLong = snippetLength ? notification.message.length > snippetLength : false;
      const message = tooLong ? `${notification.message.split(' ').slice(0, snippetLength / 5).join(' ')}... ` : notification.message;
      const link = tooLong && readMoreComponent ? readMoreComponent({
        date: notification.timestamp
      }) : null;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: idx // eslint-disable-line react/no-array-index-key

      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "h6",
        style: {
          color: _colors.slate
        }
      }, dateTimeComponent({
        date: notification.timestamp
      })), /*#__PURE__*/_react.default.createElement("div", null, message, link && /*#__PURE__*/_react.default.createElement(_InlineButton.InlineButton, {
        onClick: this.handleClose
      }, link)));
    }));

    const error = /*#__PURE__*/_react.default.createElement("b", {
      className: "text-danger"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-exclamation-triangle"
    }), " ", errorMessage);

    const popoverContents = /*#__PURE__*/_react.default.createElement("div", {
      style: {
        maxHeight: this.state.windowHeight
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        width: '246px'
      }
    }, /*#__PURE__*/_react.default.createElement("h5", null, "Notifications"), viewAllComponent && /*#__PURE__*/_react.default.createElement(_BlockButton.BlockButton, {
      style: {
        width: 'auto'
      },
      onClick: this.handleClose
    }, viewAllComponent)), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        maxHeight: this.state.windowHeight - 30,
        overflowY: 'auto'
      }
    }, notifications.length ? formattedNotifications : errorMessage ? error : noNotificationsText));

    return /*#__PURE__*/_react.default.createElement(_reactComponents.Tooltip, _extends({
      direction: "bottom",
      contents: popoverContents,
      show: this.state.show,
      onClickOutside: () => this.state.show && this.handleClose(),
      variety: "popover",
      constraints: constraints,
      style: {
        margin: '0 8px 0 0'
      }
    }, rest), /*#__PURE__*/_react.default.createElement(_InlineButton.InlineButton, {
      onClick: () => this.state.show ? this.handleClose() : this.handleOpen(),
      className: "clickable",
      style: {
        position: 'relative',
        height: '22px',
        width: '25px',
        textAlign: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-bell-o fa-lg",
      style: {
        padding: '4px 0'
      }
    }), numberUnread > 0 && /*#__PURE__*/_react.default.createElement("span", {
      style: badgeStyle
    }, numberUnread)));
  }

}

exports.Notifications = Notifications;